"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";
import QueryString from "qs";

const logisticReportsService = {
  getLogisticControlPointsReports: function (options) {
    return api.get("/ControlPoints/Reports", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  getLogisticTaskTrpsReports: function (options) {
    return api.get("/TaskTrips", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  getLogisticTaskTrpReport: function (options) {
    return api.get("/TaskTrips/" + options.id, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  logisticTaskTrpReportDownload: function (options) {
    return api.get(
      `/TaskTrips/${options.id}/Download`,
      WithToken.headersToken({ params: options, responseType: "blob" }, configuration.cookieName)
    );
  },
};

export default logisticReportsService;
